import PayrollCompany from './payrollCompany';
export default PayrollCompany;